import React,{useState} from "react";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import UITextInput from "components/ui/UITextInput";
import UINumberInput from "components/ui/UINumberInput";
import { SVGAsset } from "res";

import { useBCMSContext, useParams,BCMSRecord, useRoute } from "@bcm-dev/bcms-vite";

import Classes, { Card, LinkedAccount } from "model";

import "./styles.css";
/**
 * @function AddAccountPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AddAccountPage.
 *
 */
export default function AddAccountPage(props) {
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);
  BCMSRecord.globalControllerFor([ Card  ,LinkedAccount ], globalController);
  const navigate = useRoute();

  const [getAccountNumber,SetAccountNumber] = useState("");
  const [getType,SetType] = useState("");
  const [getRouting_number,SetRouting_number] = useState("");
  const [getReAccountNumber,SetReAccountNumber] = useState("");
  const [getLastName,SetLastName] = useState("");
  const [getFirstName,SetFirstName] = useState("");
  
  const checkLastFour = (number)=>{
    let lastFour = number.slice(-4);
    do{
      if(lastFour.length < 4)
      lastFour+= "0";
    }while(lastFour.length < 4)
    return "*"+lastFour;
  }  
  const checkType = (type)=>{
   switch(type.toLowerCase()){
      case "savings":
      case "checking":
        return type;
       break;
       default:
       return "checking"; 
   }
  }  
  
 const onClick = ()=>{
  const newAccount = LinkedAccount.init({
    "id":LinkedAccount.nextID(),
"available_credit":"20000",
"fi_name":"My Financial",
"last_four_digit_number":checkLastFour(getAccountNumber),
"routing_number":getRouting_number === ""? "987654321":getRouting_number ,
"status":"active",
"type":checkType(getType) 
  })


BCMSRecord.batch([
  LinkedAccount.create(newAccount),
  
 
],globalController, Classes);
navigate("/home/managepaymentaccounts/managepayments/"+cardID)
 }
    return (
    <MainContentContainer className="add-account-page" header={<MainContentHeader text="Add Account" />} >
      <FormContainer>
        <FormRow>
          <UITextInput placeholder="Account Type*"  onChange = {SetType} value={getType}/>
        </FormRow>
        <FormRow>
          <UINumberInput placeholder="Account Number*" onChange = {SetAccountNumber}  value={getAccountNumber}/>
        </FormRow>
        <FormRow>
          <UINumberInput placeholder="Re-enter Account Number*"  onChange = {SetReAccountNumber}  value={getReAccountNumber}/>
        </FormRow>
        <FormRow>
          <UINumberInput placeholder="Routing Number*" onChange = {SetRouting_number}  value={getRouting_number}/>
        </FormRow>
        <FormRow>
          <UITextInput placeholder="First Name*"  onChange = {SetFirstName}  value={getFirstName}/>
        </FormRow>
        <FormRow>
          <UITextInput placeholder="Last Name*" onChange = {SetLastName}  value={getLastName}/>
        </FormRow>
        <div className="flex-container flex-horizontal align-center-container info-container">
          <div className="set-width left-icon-container">
            <SVGAsset id="InformationIcon" />
          </div>
          <div className="flex-width">
            <span className="sub-text">By selecting Add Account, I acknowledge I am an owner of the account referenced above and am authorized to make payments.</span>
          </div>
        </div>
        <FormButtonContainer>
          <UIPrimaryButton text="Add Account" onClick={onClick}/>
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  )
}
